import React, { Component } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { withRouter } from "react-router";
import { endpoints } from "../../services/apiurl";
import { Card } from "@mui/material";

import DataTableExtensions from "react-data-table-component-extensions";
import moment from "moment";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

//console.log(localStorage.getItem("user"));

class PosistDetail extends Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      // all_bil: [],
      DataisLoaded: false,
      number: 1,
      empty: "",
      currentPage: 1,
      totalPages: 1,
      per_page: 10,
      id: this.props.match.params.id,
      restro_id: this.props.match.params.restro_id,
    };
 
  }


  componentDidMount() {
    this.getPosistbyid();
  }

  getPosistbyid() {
 
    var pos_id = this.state.id;
    var restro_id = this.state.restro_id;

    axios
      .post(endpoints.getPosist, {
        pos_id,
        restro_id,
      })
      .then((response) => {
        // console.log(response.data.data.length)
        if (response.data.data.length === 0) {
          this.setState({
            ...this.state,
            empty: "Error",
          });
        } else {
          this.setState({
            ...this.state,
            items: response.data.data,
            // all_bil: response.data.all_bill,
            totalPages: response.data.total_pages,
            local: localStorage.setItem(
              "data",
              JSON.stringify(response.data.data)
            ),
            DataisLoaded: true,
          });
        }

        //console.log(response.data.data);
      });
  }

  render() {
   
    const a = this.state.items;

   
   // console.log(this.state.items.length);
    for (var i = 0; i < this.state.items.length; i++) {
      const food_item = a[i];
      var food_items;
      try {
        food_items = JSON.parse(food_item["items"]);
      } catch (error) {
      //  console.error("Failed to parse items", error);
        food_items = [];
      }
      // console.log(food_items)
    }

    const ExpandedComponent =
      (suppData) =>
      ({ data }) => {
        // const a = JSON.parse(data, null, 2)
        return (
          <>
            <div className="row px-5">
              <div className="col-md-6">
                <mat-card>
                  <table>
                    <tr>
                      <th className="w-50">Name</th>
                      <td>{data.name}</td>
                    </tr>
                    <tr>
                      <th>Bill Number</th>
                      <td>{data.bill_no}</td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>{data.email}</td>
                    </tr>
                    <tr>
                      <th>Mobile</th>
                      <td>{data.mobile}</td>
                    </tr>
                    <tr>
                      <th>Loyality Point</th>
                      <td>{data.point_earn}</td>
                    </tr>
                    <tr>
                      <th>Restaurant Name</th>
                      <td>{data.restro_id}</td>
                    </tr>

                    <tr>
                      <th>Items</th>
                      <tr>
                        <th>Food Name</th> <th>Quantity</th>
                      </tr>
                      {food_items && food_items.length > 0 ? (
                        food_items.map((item) => {
                          return (
                            <tr>
                              <td>{item.name}</td>
                              <td>{item.quantity}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="2">No items available</td>
                        </tr>
                      )}
                    </tr>
                  </table>
                </mat-card>
              </div>

              <div className="col-md-6">
                <mat-card>
                  <table>
                    <tr>
                      <th className="w-75">Total Amount</th>
                      <td>{data.total_amount}</td>
                    </tr>
                    <tr>
                      <th>Discount</th>
                      <td>{data.bill_discount}</td>
                    </tr>
                    <tr>
                      <th>Total Tax</th>
                      <td>{data.total_tax}</td>
                    </tr>
                    <hr></hr>
                    <tr>
                      <th>Net Amount</th>
                      <td>{data.net_amount}</td>
                    </tr>

                    <br></br>
                    <tr>
                      <th>Create on </th>

                      <td>
                        {moment(new Date(data.settled_at)).format("DD/MM/YYYY")}
                      </td>
                    </tr>
                    <tr>
                      <th>Server Name</th>
                      <td>{data.server_name}</td>
                    </tr>
                  </table>
                </mat-card>
              </div>
            </div>
            {suppData}{" "}
          </>
        );
      };

    const columns = [
      {
        selector: (row) => row.name,
        cellExport: (row) => row.name,
        sortable: true,
      },
      {
        selector: (row) => row.email,
        cellExport: (row) => row.email,
        sortable: true,
      },
      {
        selector: (row) => row.mobile,
        cellExport: (row) => row.mobile,
        sortable: true,
      },
      {
        selector: (row) => row.bill_no,
        cellExport: (row) => row.bill_no,
        sortable: true,
      },
      {
        selector: (row) => row.restro_id,
        cellExport: (row) => row.restro_id,
        sortable: true,
      },

      {
        // selector: row => row.dob,
        cellExport: (row) => row.name,
        selector: (row) => row.name,
        // cellExport:(row) =>new Date(row.dob).toLocaleString(),
        omit: true,
        sortable: true,
      },
      {
        // selector: row => row.anniversary,
        cellExport: (row) => row.total_amount,
        selector: (row) => row.total_amount,
        // cellExport:(row) =>new Date(row.anniversary).toLocaleString(),
        omit: true,
        sortable: true,
      },
      // {

      //     selector: row => row.bill_discount,
      //     cellExport: (row) => row.bill_discount,
      //     sortable: true
      // },
      {
        selector: (row) => row.total_tax,
        cellExport: (row) => row.total_tax,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.net_amount,
        cellExport: (row) => row.net_amount,
        // omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.settled_at,
        cellExport: (row) => row.settled_at,
        omit: true,
        sortable: true,
      },

      // {

      //     selector: row => row.create_on,
      //     cellExport: (row) => row.create_on,
      //     sortable: true
      // },
      {
        selector: (row) => row.server_name,
        cellExport: (row) => row.server_name,
        omit: true,
        sortable: true,
      },
   
    ];


    const c = [
      {
        // full_name: "Name",
        address: "Address ",
        bill_no: "Bill Number",
        addrress: null,

        create_on: "Created On",
        email: "Email",
        id: 0,
        point_earn: "Loyality Point",
        mobile: "Number",

        name: "Name",

        restro_id: "Restaurant ",
        service: "Service",
        // type: "Restaurant",
        status: "Status",
        total_amount: "Total Amount",
        bill_discount: "Discount",
        total_tax: "Total Tax",
        net_amount: "Net Amount",
        settled_at: "Settled At",
        server_name: "Server Name",
      },
    ];
    // console.log(a[0]['items'])
    //  console.log(a)
    const data = c.concat(a);

    const tableData = {
      columns,
      data,
    };

    //console.log(this.state);
    return (
      <div className="App">
        {/* <PageTitle title="Amenities List" linkid={restro_id} linkurl="/dashboard/addamenities" linkTitle="Add Amenities" /> */}
        <Card className="px-3 py-3">
          {/* <div className="row">
                        {a.map((item) => {
                            return <div className="col">
                                <div className="card" style={{ width: '18rem' }}>

                                    <div className="card-body">
                                        <h5 className="card-title">Resturent Name:- {item.restro_id}</h5>
                                        <p className="card-text">No. of Bills:- {item.no_of_bils}</p>
                                       
                                        <p className="card-text">Total Amount:- {item.tot}</p>
                                        <a href="#" className="btn btn-primary">See Detail</a>
                                    </div>
                                </div>
                            </div>

                        })}
                    </div> */}

          {this.state.empty == "" && (
            <DataTableExtensions {...tableData}>
              <DataTable
                defaultSortField="id"
                pagination
                paginationPerPage={7}
                paginationRowsPerPageOptions={[7, 14, 21, 28, 35]}
                expandableRows
                exportHeaders={true}
                expandableRowsComponent={ExpandedComponent()}
              />
            </DataTableExtensions>
          )}
          {this.state.empty != "" && <p>Data Doesn't Exist</p>}
        </Card>
      </div>
    );
  }
}

export default withRouter(PosistDetail);
